import React from 'react';
import { Link } from 'react-router-dom';
import './Logo.scss';

/**
 * Logo Component
 * Un logo minimalist și modern pentru brandul nucartizanal.com
 */
const Logo = ({ linkTo = '/' }) => {
  return (
    <Link to={linkTo} className="logo">
      <div className="logo__icon">
        <svg 
          width="40" 
          height="40" 
          viewBox="0 0 100 100" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="logo__svg"
          style={{
            shapeRendering: 'geometricPrecision',
            imageRendering: '-webkit-optimize-contrast'
          }}
        >
          {/* Miez de nucă (forma stilizată originală) */}
          <path 
            d="M50 15C30 15 15 35 15 50C15 65 30 85 50 85C70 85 85 65 85 50C85 35 70 15 50 15Z" 
            className="logo__nut-meat"
          />
          
          {/* Linia din mijloc (despărțirea miezului) */}
          <path 
            d="M50 15C50 15 50 50 50 85" 
            className="logo__line"
            strokeLinecap="round"
          />
          
          {/* Coaja de nucă stilizată originală */}
          <path 
            d="M25 30C25 30 15 40 15 50C15 60 25 70 25 70M75 30C75 30 85 40 85 50C85 60 75 70 75 70" 
            className="logo__shell"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="logo__text">
        <span className="logo__brand">nucartizanal</span>
        <span className="logo__domain">.com</span>
      </div>
    </Link>
  );
};

export default Logo;
